import { Requester } from './Requester';
import { IContactRecord } from '../types';

export const CreateSurvey = async ({
    clientId,
    trigger
}: {
    clientId: string;
    trigger: string;
}): Promise<any | null> => {
    try {
        const response = await Requester<IContactRecord>({
            // port: '8080',
            path: `surveys`,
            method: 'POST',
            payload: { organizationId: clientId, trigger }
        });

        return Object.hasOwn(response, '_id') ? response : null;
    } catch (e) {
        console.error('Create new intake survey request failed');
        return Promise.reject(e);
    }
};
